import { Component, computed, inject, input } from '@angular/core';
import { MDContentBoxComponent } from '@melodic-ui/components';
import { IndicatorType } from '@melodic-ui/types/indicator-type.type';
import { AccountStateService } from '@lb/state/account-state.service';
import { buildSupportTicketUrl } from '@lb/functions/support-ticket-url.function';

export type NeedHelpCardVariant = 'default' | 'subtle';

@Component({
	selector: 'lb-need-help-card',
	standalone: true,
	imports: [MDContentBoxComponent],
	templateUrl: './need-help-card.component.html',
	styleUrl: './need-help-card.component.scss',
	host: { '[class.subtle]': 'variant() === "subtle"' }
})
export class NeedHelpCardComponent {
	private readonly _accountStateService = inject(AccountStateService);

	public variant = input<NeedHelpCardVariant>('default');

	public contentBoxType = computed<IndicatorType>(() => (this.variant() === 'subtle' ? 'disabled' : 'default'));

	public supportTicketUrl = computed(() => buildSupportTicketUrl(this._accountStateService.user()));
}
